import { useQuery } from "@tanstack/react-query";
import {
  PETS,
  USERS_CLINIC,
  USERS_CLINIC_SINGLE,
} from "../../../../enums/QueryKeys";
import {
  fetchClinicUsers,
  fetchPet,
  fetchSingleClinicUser,
} from "../../../../enums/queryFunction/Fetch";

export function useGetClinicUsers(url) {
  const { data, isLoading, error } = useQuery({
    queryKey: [USERS_CLINIC],
    queryFn: () => fetchClinicUsers(url),
    staleTime: Infinity,
  });

  return { data, isLoading, error };
}

export function useGetSingleClinicUser(user_id) {
  const { data, isLoading, error } = useQuery({
    queryKey: [USERS_CLINIC_SINGLE + user_id],
    queryFn: () => fetchSingleClinicUser(user_id),
    staleTime: Infinity,
  });

  const {
    data: pet,
    isLoading: petLoading,
    error: petErrror,
  } = useQuery({
    queryKey: [PETS + "user" + user_id],
    queryFn: () => fetchPet(user_id),
    staleTime: Infinity,
  });

  const employeeObj = {
    data: data,
    isLoading: isLoading,
    error: error,
  };

  const petObj = {
    pet,
    petLoading,
    petErrror,
  };

  return { employeeObj, petObj };
}
